import useApiClient from './api-client'
import type { ProductDetailData, FproductRemarkV2Data, ProductReviewResponse, ReviewTagsCountResponse, ReviewReviewResponse } from '@/types/api'
import type { GetProductInfoReqParams, GetProductCommentsParams } from '@/types/product'

export const getProductInfo = async (pid: string, params: GetProductInfoReqParams) => {
  const api = useApiClient<ProductDetailData>()
  const result = await api(`/product/${pid}/info`, { query: params })

  return result
}

export const getProductComments = async (pid: string | number, params: GetProductCommentsParams) => {
  const api = useApiClient<ReviewReviewResponse>()
  const result = await api(`/product/${pid}/comments`, { query: params })

  return result
}

export const getProductReviewTags = async (id: string) => {
  const api = useApiClient<ProductReviewResponse>()
  const result = await api(`/product/${id}/review-tags`)
  return result
}

export const getProductReviewTagsCount = async (id: string | number) => {
  const api = useApiClient<ReviewTagsCountResponse>()
  const result = await api(`/product/${id}/review-tags-count`)
  return result
}

export const getProductRemarks = async (pid: string) => {
  const api = useApiClient<{ list: FproductRemarkV2Data[]; total_count: number }>()
  const result = await api(`/product/${pid}/remarks`)

  return result
}
